import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import SoccerMatchBroadcastItem from './item';
import SoccerTimeLineStore from './store';
import NoneBroadcast from '../../../../../components/noneBroadcast';
import SportsLoader from '../../../../../components/sportsLoader';
import Seo from '../../../../../components/seo';

const SoccerMatchBroadcast = observer(() => {
  let { id } = useParams();
  const {
    getBrodcasts,
    timeLine,
    loading,
    closeSocket
  } = SoccerTimeLineStore();

  useEffect(() => {
    getBrodcasts(id);

    return () => {
      closeSocket();
    };
  }, []);

  const timeLineComp = [];
  timeLine.map((item, idx) => {
    timeLineComp.push(<SoccerMatchBroadcastItem key={idx} item={item} />);
  });

  if (loading) {
    return <SportsLoader />;
  } else if (timeLineComp.length > 0) {
    return (
      <>
        <Seo title={'스포츠 축구 상세 중계'} />
        <div className="soccer_cast">
          <div className="inner">{timeLineComp}</div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Seo title={'스포츠 축구 상세 중계'} />
        <NoneBroadcast />
      </>
    );
  }
});

export default SoccerMatchBroadcast;
